<template>
  <section class="price-comps">
    <template v-if="TAX_COUNTRY_ARR.includes(region.toLowerCase())">
      <div class="price-rule">
        <GeneralPrice
          :isBeat="isBeat"
          :class="isDesktop ? 'desktop-scribing' : ''"
          :price="myPrice.displayMoney"
          :isRender="price >= 0"
          :injectColor="injectColor"
          :isRenderKB="true"
        />
        <!-- 显示税额 -->
        <div
          v-if="myPrice.displayTrProce > 0"
          class="tax-rate"
          :style="taxRateColor"
        >
          +{{ myPrice.displayTrProce }} {{ myPrice.displayUnit }}
        </div>
      </div>
    </template>
    <template v-else>
      <GeneralPrice
        :isBeat="isBeat"
        :class="isDesktop ? 'desktop-scribing' : ''"
        :price="price"
        :isRender="price >= 0"
        :injectColor="injectColor"
        :isRenderKB="true"
      />
    </template>
  </section>
</template>
<script>
  import isEmpty from 'lodash/isEmpty'
  import GeneralPrice from '@/components/GeneralPrice'
  import { mapState } from 'vuex'
  import { taxPriceFunc, TAX_COUNTRY_ARR } from '@/utils/mySstHack'
  import { hexToRgba } from '@/utils/hexToRgba'
  export default {
    props: {
      // 是否展示动效
      isBeat: {
        type: Boolean,
        default: false,
      },
      // 展示的价格
      price: {
        type: Number,
        default: 0,
        required: true,
      },
      // 直接改变颜色【CP模板化】
      injectColor: {
        type: String,
        default: '',
      },
    },
    components: {
      GeneralPrice,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['region', 'isDesktop']),
      ...mapState('detail', ['detailBasicConfig']),
      TAX_COUNTRY_ARR() {
        return TAX_COUNTRY_ARR
      },
      myPrice() {
        const { commonConfig = {} } = this.detailBasicConfig
        if (isEmpty(commonConfig)) return taxPriceFunc(this.price)

        return taxPriceFunc(this.price, commonConfig.taxRate)
      },
      taxRateColor() {
        return {
          color: hexToRgba(this.injectColor, 0.5),
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .price-rule {
    display: flex;
    align-items: baseline;
    .tax-rate {
      font-size: 36px;
      padding-left: 20px;
      color: #f96000;
    }
  }
</style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    ::v-deep {
      .price-rule {
        display: flex;
        align-items: baseline;
        .tax-rate {
          font-size: 22px;
          padding-left: 20px;
          color: #f96000;
        }
      }
      .desktop-scribing {
        .sprice {
          font-size: 48px;
          color: #a24e1f;
          padding-left: 0;
        }

        .sprefix {
          .currency {
            font-size: 48px;
            color: #a24e1f;
          }
        }
      }
    }
  }
</style>
